import { helpers } from '@vuelidate/validators'

// Validator die geen letters toestaat (alleen cijfers, spaties en speciale tekens)
const noLettersRegex = /^[^a-zA-Z]*$/

export const noLetters = helpers.regex(noLettersRegex)
